import { PromiseType } from './general';
import * as ManageAlarmManager from '../data/domain/manage-alarms-manager';

export enum ManageAlarmsTabsEnum {
    bulkalarms = 'BulkAlarms',
    singlealarms = 'SingleAlarms',
}
export type FiltersData = {
    type: ManageAlarmsTabsEnum;
    locationId: string;
    siteId: string;
    deviceType: string;
    gatewayTypeId: string;
    gatewayId: string;
    alarmType: string;
};

export type GlobalFiltersData = {
    type: ManageAlarmsTabsEnum;
    locationId: string;
    siteId: string;
    gatewayId: string;
};

export type ChannelDetails = {
    name: string;
    tagId: string | number;
    devices: [];
    type?: string;
};

export type DeviceChannelCount = {
    channelCount: number;
    deviceId: string;
    deviceName: string;
};

export type ManageAlarmConfig = {
    deviceId?: string;
    tagId: string;
    tagName: string;
    priority: number;
    type: string;
    highCritical: {
        isChecked: boolean;
        limit: number;
        message: string;
    };
    lowCritical: {
        isChecked: boolean;
        limit: number;
        message: string;
    };
    highCaution: {
        isChecked: boolean;
        limit: number;
        message: string;
    };
    lowCaution: {
        isChecked: boolean;
        limit: number;
        message: string;
    };
    ackHoldOff: {
        checked: boolean;
        time: number;
    };
    rearm: {
        checked: boolean;
        time: number;
    };
    alarmDelay: {
        checked: boolean;
        time: number;
    };
    latching: boolean;
    active: boolean;
    requestedFrom: string;
};

export type ManageAdvAlarmConfig = {
    ackHoldOff: {
        checked: boolean;
        time: number;
    };
    rearm: {
        checked: boolean;
        time: number;
    };
    alarmDelay: {
        checked: boolean;
        time: number;
    };
    latching: boolean;
};

export type ManageDigitalAlarmConfig = {
    alarmEnabled: boolean;
    alarmOnValue: boolean;
    alarmMessage: string;
    alarmType: string;
    priority: number;
    ackHoldOff: {
        checked: boolean;
        time: number;
    };
    rearm: {
        checked: boolean;
        time: number;
    };
    alarmDelay: {
        checked: boolean;
        time: number;
    };
    latching: boolean;
};
export type GatewayListType = {
    gatewayId: string;
    gatewayName: string;
};
export type AlarmConfigData = PromiseType<ReturnType<typeof ManageAlarmManager.getAlarmConfig>>;

export const alarmOn = [
    { key: 'true', value: 'True' },
    { key: 'false', value: 'False' },
];

export enum OTAImageType {
    package = 'Package',
    image = 'Image',
}
